import React from 'react';
import { useNavigate } from 'react-router-dom';

function AwardPoints() {
  const navigate = useNavigate();

  return (
    <div>
      <h1>Award Points</h1>
      <p>Select how you would like to assign points:</p>

      <div style={{
        display: 'flex',
        gap: '30px',
        marginTop: '30px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => navigate('/assign/students')}
          style={cardStyle}
        >
          👤 Individual Students
        </button>

        <button
          onClick={() => navigate('/assign/roster')}
          style={cardStyle}
        >
          👥 Roster
        </button>

        <button
          onClick={() => navigate('/assign/house')}
          style={cardStyle}
        >
          🏠 House
        </button>
      </div>
    </div>
  );
}

const cardStyle = {
  width: '220px',
  height: '120px',
  fontSize: '18px',
  fontWeight: 'bold',
  borderRadius: '10px',
  border: 'none',
  backgroundColor: '#003e73',
  color: 'white',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
};

export default AwardPoints;
